module.exports = __webpack_public_path__ + "img/luxury_estate_thumbnail.cce6e93e.jpg";